<div class="dashboard-container">
    <!-- Header -->
    <div class="dashboard-header">
        <div class="header-title">
            <h4 class="mb-0">
                <i class="fas fa-chart-bar me-2"></i>
                Dashboard Programări
            </h4>
            <small class="text-muted">Statistici și analiză programări</small>
        </div>
        <div class="header-actions">
            <button class="btn btn-outline-primary btn-sm me-2" (click)="loadAllData()" [disabled]="isLoading">
                <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i> Reîncarcă
            </button>
            <button class="btn btn-outline-success btn-sm" (click)="exportData()">
                <i class="fas fa-download"></i> Export
            </button>
        </div>
    </div>

    <!-- Filters -->
    <div class="filters-card">
        <div class="row align-items-end g-3">
            <div class="col-md-2">
                <label class="form-label small">Perioadă</label>
                <select class="form-select form-select-sm" [(ngModel)]="selectedPeriod" (change)="onPeriodChange()">
                    <option *ngFor="let preset of periodPresets" [value]="preset.value">{{ preset.label }}</option>
                </select>
            </div>
            <div class="col-md-2" *ngIf="selectedPeriod === 'custom'">
                <label class="form-label small">De la</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_from">
            </div>
            <div class="col-md-2" *ngIf="selectedPeriod === 'custom'">
                <label class="form-label small">Până la</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.date_to">
            </div>
            <div class="col-md-2">
                <label class="form-label small">Modul</label>
                <select class="form-select form-select-sm" [(ngModel)]="filters.id_modul">
                    <option value="">Toate</option>
                    <option *ngFor="let m of modules" [value]="m.id">{{ m.denumire }}</option>
                </select>
            </div>
            <div class="col-md-2">
                <label class="form-label small">Locație</label>
                <select class="form-select form-select-sm" [(ngModel)]="filters.id_locatie">
                    <option value="">Toate</option>
                    <option *ngFor="let l of locations" [value]="l.id">{{ l.denumire }}</option>
                </select>
            </div>
            <div class="col-md-2">
                <label class="form-label small">Serviciu</label>
                <select class="form-select form-select-sm" [(ngModel)]="filters.id_serviciu">
                    <option value="">Toate</option>
                    <option *ngFor="let s of services" [value]="s.id">{{ s.denumire }}</option>
                </select>
            </div>
            <div class="col-md-2 d-flex gap-2">
                <button class="btn btn-primary btn-sm flex-grow-1" (click)="applyFilters()">
                    <i class="fas fa-filter"></i> Aplică
                </button>
                <button class="btn btn-outline-secondary btn-sm" (click)="resetFilters()">
                    <i class="fas fa-undo"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Se încarcă...</span>
        </div>
    </div>

    <!-- KPI Cards -->
    <div class="row g-3 mb-4">
        <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let card of kpiCards">
            <div class="kpi-card" [style.border-left-color]="card.color">
                <div class="kpi-icon" [style.background-color]="card.color + '20'" [style.color]="card.color">
                    <i class="fas" [ngClass]="card.icon"></i>
                </div>
                <div class="kpi-content">
                    <div class="kpi-value" [style.color]="card.color">
                        {{ formatNumber(+card.value) }}{{ card.suffix || '' }}
                    </div>
                    <div class="kpi-title">{{ card.title }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Charts Row -->
    <div class="row g-4 mb-4">
        <!-- Status Distribution Donut -->
        <div class="col-lg-6">
            <div class="chart-card">
                <div class="chart-container">
                    <canvas baseChart
                        [data]="statusChartData"
                        [options]="statusChartOptions"
                        type="doughnut">
                    </canvas>
                </div>
            </div>
        </div>

        <!-- Presence Distribution Donut -->
        <div class="col-lg-6">
            <div class="chart-card">
                <div class="chart-container">
                    <canvas baseChart
                        [data]="presenceChartData"
                        [options]="presenceChartOptions"
                        type="doughnut">
                    </canvas>
                </div>
            </div>
        </div>
    </div>

    <!-- Trend Chart -->
    <div class="row g-4 mb-4">
        <div class="col-12">
            <div class="chart-card">
                <div class="chart-header">
                    <span class="chart-title">
                        <i class="fas fa-chart-line me-2"></i>
                        Trend Programări
                    </span>
                    <div class="chart-controls">
                        <select class="form-select form-select-sm" [(ngModel)]="trendGroupBy" (change)="onTrendGroupByChange()" style="width: auto;">
                            <option *ngFor="let opt of trendGroupOptions" [value]="opt.value">{{ opt.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="chart-container-large">
                    <canvas baseChart
                        [data]="trendChartData"
                        [options]="trendChartOptions"
                        type="line">
                    </canvas>
                </div>
            </div>
        </div>
    </div>

    <!-- Tables Row -->
    <div class="row g-4">
        <!-- Top Services Table -->
        <div class="col-lg-8">
            <div class="table-card">
                <div class="table-header">
                    <span class="table-title">
                        <i class="fas fa-building me-2"></i>
                        Top Servicii
                    </span>
                </div>
                <div class="table-responsive">
                    <table class="table table-hover table-sm mb-0">
                        <thead>
                            <tr>
                                <th>Serviciu</th>
                                <th class="text-center">Total</th>
                                <th class="text-center">Validate</th>
                                <th class="text-center">Anulate</th>
                                <th class="text-center">Prezenți</th>
                                <th class="text-center">Absenți</th>
                                <th class="text-center">Rată Val.</th>
                                <th class="text-center">Rată Prez.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let stat of serviceStats">
                                <td>{{ stat.serviciu_name }}</td>
                                <td class="text-center">{{ formatNumber(stat.total) }}</td>
                                <td class="text-center text-success">{{ formatNumber(stat.validate) }}</td>
                                <td class="text-center text-danger">{{ formatNumber(stat.anulate) }}</td>
                                <td class="text-center text-success">{{ formatNumber(stat.prezenti) }}</td>
                                <td class="text-center text-warning">{{ formatNumber(stat.absenti) }}</td>
                                <td class="text-center">
                                    <span class="badge" [class.bg-success]="stat.rata_validare >= 70" [class.bg-warning]="stat.rata_validare >= 50 && stat.rata_validare < 70" [class.bg-danger]="stat.rata_validare < 50">
                                        {{ stat.rata_validare }}%
                                    </span>
                                </td>
                                <td class="text-center">
                                    <span class="badge" [class.bg-success]="stat.rata_prezenta >= 80" [class.bg-warning]="stat.rata_prezenta >= 60 && stat.rata_prezenta < 80" [class.bg-danger]="stat.rata_prezenta < 60">
                                        {{ stat.rata_prezenta }}%
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="serviceStats.length === 0">
                                <td colspan="8" class="text-center text-muted py-3">
                                    Nu există date pentru filtrele selectate
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Attention Needed -->
        <div class="col-lg-4">
            <div class="attention-card">
                <div class="attention-header">
                    <span class="attention-title">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        Necesită Atenție
                    </span>
                </div>
                <div class="attention-list">
                    <div class="attention-item" *ngFor="let item of attentionItems">
                        <div class="attention-icon" [ngClass]="getSeverityClass(item.severity)">
                            <i class="fas" [ngClass]="getSeverityIcon(item.severity)"></i>
                        </div>
                        <div class="attention-content">
                            <div class="attention-count" [ngClass]="getSeverityClass(item.severity)">
                                {{ formatNumber(item.count) }}
                            </div>
                            <div class="attention-label">{{ item.label }}</div>
                        </div>
                    </div>
                    <div *ngIf="attentionItems.length === 0" class="text-center text-muted py-3">
                        <i class="fas fa-check-circle fa-2x mb-2"></i>
                        <p class="mb-0">Totul este în regulă!</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
